import { Stack, Title, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import Seo from '../../components/Seo.tsx';

export default function TermsOfUse() {
  const { t } = useTranslation();

  const seoTitle = t('seo.termsTitle');
  const seoDescription = t('seo.termsDescription');

  const sections: Array<{ title: string; paragraphs: string[] }> = [
    {
      title: t('terms.sections.purpose.title'),
      paragraphs: [
        t('terms.sections.purpose.p1'),
      ],
    },
    {
      title: t('terms.sections.acceptance.title'),
      paragraphs: [
        t('terms.sections.acceptance.p1'),
      ],
    },
    {
      title: t('terms.sections.intellectualProperty.title'),
      paragraphs: [
        t('terms.sections.intellectualProperty.p1'),
      ],
    },
    {
      title: t('terms.sections.accuracy.title'),
      paragraphs: [
        t('terms.sections.accuracy.p1'),
      ],
    },
    {
      title: t('terms.sections.liability.title'),
      paragraphs: [
        t('terms.sections.liability.p1'),
      ],
    },
    {
      title: t('terms.sections.externalLinks.title'),
      paragraphs: [
        t('terms.sections.externalLinks.p1'),
      ],
    },
    {
      title: t('terms.sections.modifications.title'),
      paragraphs: [
        t('terms.sections.modifications.p1'),
      ],
    },
  ];

  return (
    <>
      <Seo title={seoTitle} description={seoDescription} canonicalPath="/terms-of-use" type="article" />
      <Stack gap="xl" py="xl">
        <Stack gap={4}>
          <Title order={1}>{t('terms.title')}</Title>
          <Text c="dimmed">{t('terms.lastUpdated')}</Text>
        </Stack>

        <Stack gap="xl">
          {sections.map((section) => (
            <Stack key={section.title} gap="sm">
              <Title order={3}>{section.title}</Title>
              <Stack gap="xs">
                {section.paragraphs.map((paragraph, idx) => (
                  <Text key={idx}>{paragraph}</Text>
                ))}
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </>
  );
}
